import Panzoom from '@panzoom/panzoom';
import Swiper, { Navigation } from 'swiper';

export default function drag() {
    const overlaySingle = $('.overlaySingle');
    const seeMoreBtn = $('.seeMoreBtn');
    const controlMap = $('.controlMap');
    const menuAllplaces = $('.menu-allplaces');
    const infoboxWrapper = $('.infobox__wrapper');
    const placeIcon = $('.place--icon');
    const place = $('.place');
    const infobox = $('.infobox');
    const blackfiltermap = $('.blackfiltermap');
    const closeDiv = $('.close-div');
    const loading = $('.loading');
    const mapdiv = document.getElementById('mapdiv');

    initializeOverlay();
    initializeSwiper();
    initializePanzoom();
    bindEvents();


    function initializeOverlay() {
        let data = sessionStorage.getItem('clé');
        overlaySingle.toggle(data !== 'set').addClass('opacityFull');

        $('.lang-item').on('click', () => overlaySingle.slideUp());
        setTimeout(() => {
            sessionStorage.setItem('clé', 'set');
            $('.loadingMap').fadeOut(500);
        }, 1000);
    }

    function initializeSwiper() {
        Swiper.use([Navigation]);
        if ($('body').hasClass('template-places')) {
            $('html').css('overflow', 'hidden');
            new Swiper('.swiper-all-stations', {
                slidesPerView: 'auto',
                spaceBetween: 30,
            });
        }
    }

    function initializePanzoom() {
        const startScale = 0.6;
        if (mapdiv) {
            const viewportWidth = window.innerWidth;
            const elementWidth = 2500; 
            const startX = -(elementWidth - viewportWidth - 400);
            const startY = -180;
            const panzoom = Panzoom(mapdiv, {
                maxScale: 3,
                startScale: startScale,
                minScale: 0.3,
                startX: startX,
                startY: startY,
                disableYAxis: false,
                contain: 'outside',
            });
            console.log(elementWidth)
            console.log(viewportWidth)
            console.log(startX)
    
            $('.zoomPlus').on('click', () => panzoom.zoomIn());
            $('.zoomMinus').on('click', () => panzoom.zoomOut());
    
            mapdiv.parentElement.addEventListener('wheel', panzoom.zoomWithWheel);
        }
    }
    

    function bindEvents() {
        seeMoreBtn.on('click', toggleMapMenu);
        $('.menu-allplaces, .seeMoreBtn').on('keyup', handleEscapeKeyPress);
        blackfiltermap.add(closeDiv).on('click', () => closeMapElements());
        infobox.on('keyup', handleEscapeKeyPress);
    }

    function toggleMapMenu() {
        controlMap.toggleClass('openMapMenu');
        seeMoreBtn.toggleClass('seeMoreBtnRotated');
        menuAllplaces.toggleClass('openlist show');

        const state = seeMoreBtn.attr('aria-expanded');
        seeMoreBtn.attr('aria-expanded', state !== 'true');
    }

    function handleEscapeKeyPress(e) {
        if (e.key === 'Escape') {
            closeMapElements();
        }
    }

    
    function closeMapElements() {
        loading.show();
        placeIcon.attr('fill', '#E3000B');
        infobox.removeClass('open');
        blackfiltermap.hide();
        closeDiv.hide();
        place.removeClass('activepin');

        infoboxWrapper.removeClass('overflow').attr('aria-expanded', false)
            .removeClass('show');

        setTimeout(() => infoboxWrapper.removeClass('show'), 500);
    }
}



// WEBPACK FOOTER //
// ./scripts/modules/drag.js